import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

const Container = ({
  children,
  fullWidth,
  white,
  isMobile,
  marginBottom,
  ...props
}) => (
  <StyledRoot
    fullWidth={fullWidth}
    isMobile={isMobile}
    marginBottom={marginBottom}
    white={white}
    {...props}
  >
    <StyledContainer fullWidth={fullWidth} isMobile={isMobile} white={white}>
      {children}
    </StyledContainer>
  </StyledRoot>
);

const widthDesktop = 960;
const widthDesktopMax = 1260;
const widthMobile = 320;
const padding = 10;
const paddingMobile = 5;

const StyledRoot = styled.div`
  position: relative;
  margin-bottom: ${(props) => props.marginBottom}px;
  min-width: ${(props) => (props.isMobile ? widthMobile : widthDesktop)}px;

  ${(props) =>
    props.white &&
    css`
      background-color: ${props.theme.colors.white};
    `}
`;

const StyledContainer = styled.div`
  ${(props) =>
    !props.fullWidth &&
    css`
      margin: 0 auto;
      padding-right: ${padding}px;
      padding-left: ${padding}px;
      box-sizing: content-box;
      min-width: ${widthDesktop - padding * 2}px;
      max-width: ${widthDesktopMax - padding * 2}px;
    `}

  ${(props) =>
    props.isMobile &&
    css`
      width: auto;
      min-width: auto;
      max-width: none;
    `};

  ${(props) =>
    props.isMobile &&
    !props.white &&
    !props.fullWidth &&
    css`
      padding-right: ${paddingMobile}px;
      padding-left: ${paddingMobile}px;
    `};
`;

Container.propTypes = {
  children: PropTypes.node.isRequired,
  fullWidth: PropTypes.bool,
  white: PropTypes.bool,
  isMobile: PropTypes.bool,
  marginBottom: PropTypes.number,
};

Container.defaultProps = {
  fullWidth: false,
  white: false,
  isMobile: false,
  marginBottom: 10,
};

export default Container;
